import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { ApiExError } from '@shared';

export interface AdvisorOnboardingState {
  data: AdvisorOnboardingStatus | null;
  status: 'loading' | 'complete' | 'error' | null;
}

export const initialAdvisorOnboardingState: AdvisorOnboardingState = {
  data: null,
  status: null,
};

const advisorOnboardingSlice = createSlice({
  name: 'advisorOnboarding',
  initialState: initialAdvisorOnboardingState,
  reducers: {
    fetchAdvisorOnboardingStatusByAdvisorIdRequest: (
      state,
      _action: PayloadAction<{ advisorId: string }>,
    ) => {
      state.status = 'loading';
    },
    fetchAdvisorOnboardingStatusByAdvisorIdResponse: (
      state,
      action: PayloadAction<AdvisorOnboardingStatus>,
    ) => {
      state.status = 'complete';
      state.data = action.payload;
    },
    fetchAdvisorOnboardingStatusByAdvisorIdFailure: (state, _action: PayloadAction<ApiExError>) => {
      state.status = 'error';
    },
    putAdvisorOnboardingCompletedStepsByAdvisorIdRequest: (
      state,
      _action: PayloadAction<{ advisorId: string; completedSteps: string[] }>,
    ) => {
      state.status = 'loading';
    },
    putAdvisorOnboardingCompletedStepsByAdvisorIdResponse: (
      state,
      action: PayloadAction<AdvisorOnboardingCompletedSteps>,
    ) => {
      state.status = 'complete';
      if (state.data) {
        state.data.completedSteps = action.payload;
      }
    },
    putAdvisorOnboardingCompletedStepsByAdvisorIdFailure: (
      state,
      _action: PayloadAction<ApiExError>,
    ) => {
      state.status = 'error';
    },
    resetAdvisorOnboardingStatus: state => {
      state.data = null;
      state.status = null;
    },
  },
});

export const {
  fetchAdvisorOnboardingStatusByAdvisorIdRequest,
  fetchAdvisorOnboardingStatusByAdvisorIdResponse,
  fetchAdvisorOnboardingStatusByAdvisorIdFailure,
  putAdvisorOnboardingCompletedStepsByAdvisorIdRequest,
  putAdvisorOnboardingCompletedStepsByAdvisorIdResponse,
  putAdvisorOnboardingCompletedStepsByAdvisorIdFailure,
  resetAdvisorOnboardingStatus,
} = advisorOnboardingSlice.actions;

export const advisorOnboardingReducer = advisorOnboardingSlice.reducer;
